/* eslint-disable */
import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const useContactUs = () => {
  const createContactUs = useCallback(async (values) => {
    try {
      return await ajax.post('contact-us/create', values, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      return error;
    }
  }, []);

  return {
    createContactUs,
  };
};

export default useContactUs;
